/* eslint-disable no-param-reassign */
import { ReactNativeBridge } from "vue-app/utils/reactNativeBridge";

(function (h, o, t, j, a, r) {
  const isMobileApp = ReactNativeBridge.checkIsWebViewMode();
  const isDemo = window.EDRONE_CONTEXT?.isDemo;

  // Use different Hotjar IDs for mobile app
  // demo and production environments is set for backwards compatibility
  const hotjarID = isMobileApp ? "6437422" : isDemo ? "2190135" : "2190140";

  h.hj =
    h.hj ||
    function () {
      (h.hj.q = h.hj.q || []).push(arguments);
    };
  h._hjSettings = { hjid: hotjarID, hjsv: 6 };
  a = o.getElementsByTagName("head")[0];
  r = o.createElement("script");
  r.async = 1;
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
  a.appendChild(r);

  if (window.EDRONE_CONTEXT) {
    window.hj("identify", window.EDRONE_CONTEXT.trackerId, {
      ...window.EDRONE_CONTEXT,
      isMobileApp,
    });
  }
})(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
